
<template>
  <!--群聊管理-->
  <div>
    <template v-if="$route.query.nick_name">
      <p class="desc">
        <span>{{$route.query.nick_name}}</span> 所在的群聊
      </p>
      <a-divider class="divider"></a-divider>
    </template>

    <x-tabula
      :apiOrigin="apiOrigin"
      ref="table"
      :excludeResetKey="['user_id']"
      :dataSource="dataSource"
      rowKey="chat_group_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      @resetSearch = "resetSearch"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'groupChat',
  data () {
    return {
      apiOrigin: 'PHP',
      searchList: [
        { props: ['keywords'], placeholder: '群名、群ID', options: [], inputType: 'input' },
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select', fetchOptions: this.getOptions},
        { props: ['type'], placeholder: '群类型', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.chatStatusList, inputType: 'select' },
        {
          props: ['area_id'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(4, 'searchList', '1,2,3', e);
          }
        },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        community_id: undefined,
        type: undefined,
        status: undefined,
        area_id: undefined,
        create_date: undefined,
        chat_user_id: undefined
      },
      tableOptList: [],
      rowOptList: [
        { text: '群成员', handle: record => this.toChatMember(record), permi: ['neighbour:groupChat:member'] },
        { text: '群已禁言用户', handle: record => this.toBanned(record), permi: ['neighbour:groupChat:banned'] },
        {
          text: '',
          handle: record => this.cancelGroup(record),
          rowOptText: this.groupChatStatus,
          customRender: true,
          permi: ['neighbour:groupChat:status']
        },
        { text: '解散', handle: (record) => this.dismiss(record), rowOptDisHandle: row => row.type === 1, permi: ['neighbour:groupChat:dismiss'] }
      ],
      columns: [
        { title: '群聊ID', dataIndex: 'group_account', align: 'left', width: '' },
        { title: '群聊名称', dataIndex: 'group_name', align: 'left', width: '' },
        { title: '人数', dataIndex: 'member_count', align: 'left', width: '' },
        { title: '群类型', dataIndex: 'type_desc', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '群主', dataIndex: 'group_owner', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '群状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: 'chat/group',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    let id = this.$route.query.id;
    id && (this.searchParams.user_id = id);
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '1');
      this.searchList[1].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', 1);
    },
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(4);
      // this.communitySelect(1, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', 1);
      this._get({
        url: '/chat/group/selectlist',
        params: {}
      }).then(({data}) => {
        this.searchList[2].options = data.group_type;
      });
    },
    isCanDismiss () {},
    /** 群聊状态文本展示 */
    groupChatStatus (record) {
      if (record.status === 0) {
        return '解禁';
      } else {
        return '禁言';
      }
    },
    /** 切换群聊状态 */
    cancelGroup (record) {
      let status = record.status;
      this.$confirm({
        title: status === 1 ? '确定禁言此群聊吗？' : '确定解禁此群聊吗',
        okType: 'danger',
        centered: true,
        onOk: () => {
          this._post({
            url: '/chat/group/change',
            params: {
              chat_group_id: record.chat_group_id,
              status: status === 1 ? 0 : 1
            }
          }).then(({data}) => {
            this.$message.success(status === 1 ? '禁言成功' : '解禁成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    /** 解散群聊 */
    dismiss (record) {
      this.$confirm({
        title: '确定解散此群聊吗？',
        okType: 'danger',
        centered: true,
        onOk: () => {
          this._delete({
            url: '/chat/group',
            params: {
              pk_key: 'chat_group_id',
              pk_val: record.chat_group_id
            }
          }).then(({data}) => {
            this.$message.success('解散成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    /** 进入群成员 */
    toChatMember (record) {
      this.$router.push({
        name: 'chatMember',
        query: {
          id: record.chat_group_id,
          name: record.group_name,
          type: record.type_desc
        }
      });
    },
    /** 进入已禁言用户 */
    toBanned (record) {
      this.$router.push({
        name: 'banned',
        query: {
          id: record.chat_group_id,
          name: record.group_name,
          type: record.type_desc
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
<style lang="scss">
  .desc {
    font-size: 16px;
    span {
      color: #1890ff;
    }
  }
  .divider {
    margin-top: 16px;
  }
</style>
